// La card compacta del mockup (`.card-compact`): cabecera con título en versalitas y una meta a la
// derecha, cuerpo a sangre.
import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';
import { OriginationHelpButton, type OriginationHelpTopic } from './OriginationHelp';

export function OriginationCard({
    title,
    meta,
    help,
    wide = false,
    className,
    children,
}: {
    title: string;
    meta?: ReactNode;
    /** El `?` del mock. Solo lo llevan los cuadros que existen: el resto no tiene qué explicar. */
    help?: OriginationHelpTopic;
    wide?: boolean;
    className?: string;
    children: ReactNode;
}) {
    return (
        <section
            className={cn(
                'flex min-h-0 flex-col overflow-hidden rounded-md border border-border bg-card',
                wide && 'col-span-2',
                className,
            )}
            aria-label={title}
        >
            <div className="flex flex-none items-center justify-between gap-2 border-b border-border bg-muted/30 px-3 py-[7px]">
                {/* `h2` y no `span`: sin encabezados, un lector de pantalla no tiene por dónde
                    navegar un tablero de cards. */}
                <h2 className="flex items-center text-[11px] font-semibold uppercase tracking-[0.04em]">
                    {title}
                    {help ? <OriginationHelpButton topic={help} /> : null}
                </h2>
                {meta ? (
                    <span className="text-[10.5px] tabular-nums text-muted-foreground">{meta}</span>
                ) : null}
            </div>
            <div className="flex min-h-0 flex-1 flex-col overflow-hidden">{children}</div>
        </section>
    );
}
